import { forwardRef } from 'react'
import { FieldValues, useController, FieldPath } from 'react-hook-form'
import { DatePickerProps } from '@mui/x-date-pickers'
import DateTimeValueInput, {
  DateTimeValueInputProps,
} from '../inputs/DateTimeValueInput'

type FormDateTimeFieldProps<FormValues extends FieldValues> = {
  name: FieldPath<FormValues>
  label: string
} & Omit<
  DateTimeValueInputProps<DatePickerProps<Date>>,
  'onChange' | 'value' | 'renderInput'
>

const FormDateTimeField = forwardRef(function FormDateTimeField<
  FormValues extends FieldValues,
>(
  { name, required, ...props }: FormDateTimeFieldProps<FormValues>,
  ref: React.Ref<HTMLInputElement>,
) {
  const { field } = useController<FormValues>({
    name,
    rules: {
      required,
    },
  })

  // DateTimeValueInput is a plain function component and can't receive a `ref`,
  // so react-hook-form's `field.ref` is dropped from the spread (it wasn't
  // reaching the input before either). The forwarded ref is wired to the input
  // via `inputRef`, matching the other Form* field components.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ref: _fieldRef, ...fieldProps } = field

  return <DateTimeValueInput {...props} {...fieldProps} inputRef={ref} />
})

export default FormDateTimeField
